import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #494949;
  border-radius: 6px;
  gap: 1rem;
  padding: 0.5rem;
  margin-top: 10px;
`

export const Icon = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 50%;
  background-color: #ffccb9;
  max-width: 10rem;
  cursor: pointer;
`
export const Information = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  > div {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    gap: 3rem;
    > span {
      /* width: 100%; */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > #title {
      font-size: ${(props) => props.theme.font.textxl};
      color: ${(props) => props.theme.color.neutral.gray};
      font-weight: 500;
      align-items: center;
    }

    > #name {
      font-size: ${(props) => props.theme.font.textsm};
      color: ${(props) => props.theme.color.neutral.gray};
      width: 8.75rem;
      font-weight: 700;
      font-weight: 700;
    }

    > #alert {
      font-size: ${(props) => props.theme.font.textsm};
      color: ${(props) => props.theme.color.neutral.gray};
    }
  }
`
export const View = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 50%;
  cursor: pointer;
`
